var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaymentResultSuccess = function SvgPaymentResultSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#payment-result-success_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#payment-result-success_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.202 2.406c.306-.827 1.475-.827 1.78 0l1.522 4.113a.95.95 0 0 0 .561.56l4.113 1.522c.826.306.826 1.475 0 1.78l-4.113 1.523a.95.95 0 0 0-.56.56l-1.523 4.114c-.305.826-1.474.826-1.78 0l-1.522-4.114a.949.949 0 0 0-.56-.56l-4.114-1.522c-.826-.306-.826-1.475 0-1.78l4.113-1.523a.949.949 0 0 0 .561-.56l1.522-4.113Z",
    fill: "#FAD846"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#payment-result-success_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10.47a.411.411 0 0 1 .772 0l.66 1.783c.041.113.13.202.243.243l1.782.66a.411.411 0 0 1 0 .771l-1.782.66a.41.41 0 0 0-.243.243l-.66 1.783a.411.411 0 0 1-.772 0l-.66-1.783a.411.411 0 0 0-.242-.243l-1.783-.66a.411.411 0 0 1 0-.771l1.783-.66a.412.412 0 0 0 .243-.243l.66-1.782Z",
    fill: "#FAD846"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#payment-result-success_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.651 18.745c.13-.351.626-.351.756 0l.646 1.746c.041.11.128.197.238.238l1.746.646c.351.13.351.626 0 .756l-1.746.646a.403.403 0 0 0-.238.238l-.646 1.746a.403.403 0 0 1-.756 0l-.646-1.746a.403.403 0 0 0-.238-.238l-1.746-.646a.403.403 0 0 1 0-.756l1.746-.646a.403.403 0 0 0 .238-.238l.646-1.746Z",
    fill: "#FAD846"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#payment-result-success_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.437 59.52a.6.6 0 0 1 1.126 0l.962 2.6a.6.6 0 0 0 .354.355l2.6.962a.6.6 0 0 1 0 1.126l-2.6.962a.6.6 0 0 0-.354.354l-.962 2.6a.6.6 0 0 1-1.126 0l-.962-2.6a.6.6 0 0 0-.354-.354l-2.6-.962a.6.6 0 0 1 0-1.126l2.6-.962a.6.6 0 0 0 .354-.354l.962-2.6Z",
    fill: "#FAD846"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.178 51.868a1.663 1.663 0 0 1-2.356 0l-9.41-9.411a2.499 2.499 0 0 1 0-3.535l1.178-1.179a2.499 2.499 0 0 1 3.535 0L35 43.618l15.875-15.875a2.499 2.499 0 0 1 3.535 0l1.178 1.179c.977.976.977 2.56 0 3.535l-19.41 19.411Z",
    fill: "#18D28F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "payment-result-success_svg__b",
    x: -39.616,
    y: -35.716,
    width: 105.416,
    height: 105.416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.501
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_8241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_813_8241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "payment-result-success_svg__c",
    x: -4.71,
    y: -14.179,
    width: 65.193,
    height: 65.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.628
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_8241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_813_8241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "payment-result-success_svg__d",
    x: -37.449,
    y: -13.358,
    width: 82.957,
    height: 82.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_8241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_813_8241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "payment-result-success_svg__e",
    x: 7.233,
    y: 11.716,
    width: 123.533,
    height: 123.533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.483
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.448
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_8241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_813_8241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "payment-result-success_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgPaymentResultSuccess;